import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth";
import { Card, Button } from "@/components/primitives";

// Zero-data empty state — reads as a normal state, not an error.
// Reuses Card + Button primitives only; tokens.css colours only.
// CTA routes super admins to Connection (where the sync lives); everyone
// else to Data Health, which they can access.
export default function EmptyStateCard({
  title = "No data yet",
  message = "No data yet — run a sync to pull your Simpro history.",
  cta = "Run first sync",
  style = {},
  testid = "empty-state",
}) {
  const nav = useNavigate();
  const { user } = useAuth();
  const dest = user?.role === "super_admin" ? "/connection" : "/health";

  return (
    <Card data-testid={testid} style={{ padding: "48px 40px", ...style }}>
      <div style={{ maxWidth: 460 }}>
        <div
          className="num"
          style={{ fontSize: 20, fontWeight: 600, letterSpacing: "-0.3px", color: "var(--ui-text-hi)" }}
        >
          {title}
        </div>
        <div
          className="prose-i"
          style={{ fontSize: 14, color: "var(--ui-text-lo)", marginTop: 8, lineHeight: 1.5 }}
        >
          {message}
        </div>
        <div style={{ marginTop: 22 }}>
          <Button data-testid="empty-state-cta" onClick={() => nav(dest)}>
            {cta}
          </Button>
        </div>
      </div>
    </Card>
  );
}
